import {createStyles} from '@mantine/core';
import React from 'react';

import {assert} from 'Asserts';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import {ExperimentMethod} from '../design-state/ExperimentalInputs';

interface ProcedureRunMethodSelectDropdownProps {
  methods: Array<Pick<ExperimentMethod, 'id' | 'name'>>;
  selectedMethodId: string;
  onChangeSelectedMethod: (methodId: string) => void;
}

export default function ProcedureRunMethodSelectDropdown(
  props: ProcedureRunMethodSelectDropdownProps
): JSX.Element {
  const {methods, selectedMethodId, onChangeSelectedMethod} = props;
  const {classes} = useStyles();
  const selectedMethod = methods.find((method) => method.id === selectedMethodId);
  assert(selectedMethod != null, 'Selected method should not be null');

  return (
    <SelectDropdown
      menu={
        <Menu height={Menu.HEIGHTS.SMALL} width={Menu.WIDTHS.SMALL} value={selectedMethod.id}>
          {methods.map((method) => (
            <Option key={method.id} value={method.id} onSelect={onChangeSelectedMethod}>
              {method.name}
            </Option>
          ))}
        </Menu>
      }
      alwaysDropDown={true}
      displayName={selectedMethod.name}
      shouldEllipsize={true}
      className={classes.selectDropdown}
    />
  );
}

const useStyles = createStyles({
  selectDropdown: {
    width: '180px',
  },
});
